import React, {useRef, useState} from 'react';
import { WhatsAppMarkdown } from '../../whats-markdown/WhatsAppMarkdown';
import { load } from '../../bot-loaders';
import { Loading } from '../../components/Loading';
import { ReactTooltip } from 'tooltip';


type GptProps = {
    template:string, 
    variables:string[], 
    onCancel():void, 
    onSuggestion(text:string):void
}

type GptState = "question" | "loading" | "loaded" | "error"

export function GPTWizard({template, variables, onCancel, onSuggestion}: GptProps){
    const [state, setState] = useState<GptState>("question");
    const ref = useRef<HTMLTextAreaElement>(null);
    const [result, setResult] = useState<string>(null)
    const [hint, setHint] = useState("");

    async function gptLoad(){
        setState("loading");
        try {
            const res = await load("gpt", {variables, template, hint: hint.trim()})
            setResult(res.result)
            setState('loaded');
        } catch(e){
            setState("error");
        }

    }

    if (state == 'question'){
        return <>
            Deseja usar o Chat GPT para melhorar a sua mensagem?

            <hr />

            <WhatsAppMarkdown message={template} />

            <hr />

            Alguma sugestão adicional: <small>(opcional)</small>
            <textarea ref={ref} rows={3} className='form-control mt-3' value={hint} onChange={(e) => setHint(e.target.value)} />
            
            <div className='text-right mt-3'>
                <button className='btn btn-outline-primary me-2' onClick={onCancel}>Voltar</button>
                <button className='btn btn-primary' onClick={gptLoad}>Usar Chat GPT</button>
            </div>
            
        </>
    }

    if(state == 'loading')
        return <Loading label='Gerando novo modelo de mensagem...' />

    if(state == 'loaded')
        return <>
            <div className='d-flex mb-3 align-items-center'>
                <div className='flex-grow-1'>Versão sugerida:</div> 
                <ReactTooltip className='float-end' placement='bottom-end' tooltip="Gerar outra opção!">
                    <a className='link' onClick={gptLoad}><i className='fa fa-repeat'></i></a>
                </ReactTooltip>
            </div>
            <hr />
            
            <WhatsAppMarkdown message={result} />

            <hr />

            <div className='text-right mt-3'>
                <button className='btn btn-outline-primary me-2' onClick={() => setState('question')}>Voltar</button>
                <button className='btn btn-primary' onClick={() => onSuggestion(result)}>Usar Sugestão</button>
            </div>
        </>

    return <>Erro</>
}